import * as React from 'react';
import { useCookies } from 'react-cookie';
import { cookiesOptions } from '../shared/utils';

interface PageWidthContextValue {
    fullWidth: boolean,
    setFullWidth: (value: boolean) => void,
    toggleFullWidth: () => void,
}

export const PageWidthContext = React.createContext<PageWidthContextValue>({
    fullWidth: false,
    setFullWidth: () => undefined,
    toggleFullWidth: () => undefined,
});

export const usePageWidthState = (): PageWidthContextValue => {
    const [cookies, setCookie] = useCookies();
    const [fullWidth, setFullWidthState] = React.useState(cookies['VIEW_FULL_WIDTH'] === 'true');

    const setFullWidth = React.useCallback((value: boolean) => {
        setCookie('VIEW_FULL_WIDTH', value, cookiesOptions);
        setFullWidthState(value);
    }, [setCookie]);

    const toggleFullWidth = React.useCallback(() => {
        setFullWidth(!fullWidth);
    }, [fullWidth, setFullWidth]);

    return React.useMemo(() => ({
        fullWidth,
        setFullWidth,
        toggleFullWidth,
    }), [fullWidth, setFullWidth, toggleFullWidth]);
}

export const usePageWidth = (): PageWidthContextValue => React.useContext(PageWidthContext);
